<template>
	<div class="main bg-white">
		<div class="content-wrapper">
			<headers ref="headered"></headers>
			<div style="display:flex;flex:1;border:1px solid #f5f5f5;">
				<chatList @setDataId="setDataId" ref="chatlists"></chatList>
				<div class="chat-content">
					<div class="chat-body">
						<happy-scroll hide-horizontal resize :scroll-top="scrollTop" @vertical-start="scrollHandler">
							<div style="width: 600px; padding:20px;margin-bottom:20px;" id="chat_scroll"
								ref="scrollBox">
								<div class="chat-item" v-for="(item,index) in msglist" :key="index"
									:id="`chat_${item.id}`">
									<template v-if="item.msg_type!='remark'">
										<div class="time">{{item.time?item.time:item.show_time }}</div>
										<div :class="item.position=='left'?'flex-box':'u-f r_msg_b allnr rgs' ">
											<div class="avatar">
												<img :src="item.show_avatar" alt="">
											</div>
											<div class="mag_r">
												<div class="mc">{{item.show_nickname}}</div>
												<div class="msg_in_b">
													<div class="msg-wrapper">
														<template v-if="item.send_context&&item.send_context[0]=='{'">
															<div class="content_b" v-if="item.type=='wszl'">
																请在用户端完善资料
															</div>
															<div class="sharewz_b u-f " v-if="item.type=='wz'">
																<div class="wz_img">
																	<el-image style="width: 70px; height: 70px"
																		:src="item.info.img" fit="cover"></el-image>
																</div>
																<div class="wz_info">
																	<div class="wztit">{{item.info.name}}</div>
																	<div class="wzcons" v-html="item.info.content">
																	</div>
																</div>
															</div>
															<div class="wz_b" v-else-if="item.type=='shop'">
																<div class="s_cover"
																	:style="'background:url('+item.info.cover+')'">
																</div>
																<div class="s_price">
																	￥<span class="s_p_in">{{item.info.min_price}}</span>
																</div>
																<div class="s_tit">
																	{{item.info.title}}</div>
																<div class="s_con">
																	{{item.info.desc}}</div>

															</div>
														</template>
														<div v-else>
															<div class="content_b" v-if="item.msg_type=='text'"
																v-html="item.send_context">
																<!-- {{item.send_context}} -->
															</div>
															<div v-if="item.msg_type=='image'">
																<img :src="`${item.send_context}`" alt="" width="100%">
															</div>
														</div>
													</div>
													<template v-if="item.position!='left'">
														<div class="wd" v-if="item.is_read==2">
															未读
														</div>
														<div class="yd" v-else>
															已读
														</div>
													</template>
												</div>
											</div>
										</div>
									</template>
								</div>
							</div>
						</happy-scroll>
					</div>
					<div class="chat-textarea">
						<div class="chat-btn-wrapper">
							<div class="left-wrapper">
								<div class="icon-item" @click.stop="isEmoji = !isEmoji">
									<i class="el-icon-user iconfont"></i>
								</div>
								<div class="icon-item" v-if="to_user">
									<el-upload class="upload-demo" action="/admin/getMediaId" accept="image/*"
										name="media" :on-success='handleSuccess' :show-file-list="false">
										<i class="el-icon-picture-outline iconfont"></i>
									</el-upload>
								</div>
								<div class="icon-item" @click.stop.stop="isMsg = true"><span
										class="iconfont iconliaotian"></span></div>
							</div>
							<div class="right-wrapper">
								<div class="icon-item">
									<span class="iconfont iconzhuanjie"></span>
									<span class="sy_time" v-if="xxitem.inquiry_type!=4&&to_user"
										:class="{zx_js:!vshow}">{{vshow?sytime:'咨询结束'}}</span>
									<span class="sy_time" v-if="xxitem.inquiry_type==4&&to_user"
										:class="{zx_js:!vshow}">{{vshow?input_tip:'用户咨询次数已使用完毕，咨询结束，可'}}</span>
									<span @click="songcount" v-if="xxitem.inquiry_type == 4&&to_user">赠送次数</span>
									<!-- <span @click="dk">断开</span> -->
								</div>
							</div>
						</div>
						<div class="textarea-box" style="position:relative;">
							<el-input v-model="value.text" placeholder="请输入内容" type="textarea" ref="textbox" :rows="4"
								style="font-size:14px" @keydown.native="listen($event)"></el-input>
							<div class="send-btn">
								<el-button class="btns" type="primary" v-if="to_user" @click.stop="on.send()">发送
								</el-button>
							</div>
						</div>
					</div>
				</div>
				<div class="right_b">
					<userDetail v-if="top_tabId==0" :to_user='to_user' ref="userDetail" />
					<tranOrder v-if="top_tabId==1" :to_user='to_user' ref="tranorder" />
					<orderDetail v-if="top_tabId==2" :to_user='to_user' ref="orderDetail" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	import headers from "../component/header.vue";
	import chatList from "../component/chatList.vue";
	import tranOrder from "../component/tranOrder.vue";
	import userDetail from "../component/userDetail.vue";
	import orderDetail from "../component/orderDetail.vue";
	import opws from "../../../common/openws";
	import {
		HappyScroll
	} from 'vue-happy-scroll'
	export default {
		components: {
			headers,
			chatList,
			HappyScroll,
			tranOrder,
			userDetail,
			orderDetail,
		},
		data() {
			var vue = this;
			return {
				opws,
				chatCon: '',
				records: [],
				scrollTop: 0,
				isScroll: true,
				upperId: 0,
				disabled: true,
				value: {
					text: '',
				},
				msglist: [],
				user_type: '',
				user_id: "",
				to_user: '',
				to_order: '',
				page: 1,
				usered: '',
				top_tabId: 0,
				xxitem: '',
				mr_count: 0,
				zx_timer: 0,
				zx_count: 0,
				vshow: true,
				timer: null,
				djs: null,
				sytime: '',
				zx_S_count: 0,
				input_tip: '',
				on: {
					async connect(t) {


						if (t != 1) {
							setTimeout(() => {
								vue.$nextTick(async () => {
									vue.user_type = vue.$openws.user_type; //自己的type
									vue.user_id = vue.$openws.user_id;
									vue.usered = vue.$openws.doctor[0]
									vue.$refs.headered.doctor = vue.$openws.doctor
									vue.$refs.headered.doc_id = vue.$openws.doctor[0].id
									vue.$refs.chatlists.doc_data = vue.$openws.doctor[0]
									sessionStorage.setItem('doc_data', JSON.stringify(vue.$openws
										.doctor[0]))
									vue.$refs.chatlists.getList()
									await vue.$openws.getover('inquiry', '')
									await vue.$refs.headered.getis_noread()
								})
							}, 1000)
						}
						vue.$openws.ws.msg = async function (user_id, kefu_id, text) {
							if (text.list && text.list.length > 0) {
								vue.$refs.chatlists.userList = text.list
							}
							if (text.xx_type == "receipt") {
								if (text.from_identity == vue.to_user.from_identity) {
									vue.msglist.forEach(ele => {
										if (ele.is_read == 2) {
											ele.is_read = 1
										}
									});
								}
							}
							if (text.xx_type == 'self') {
								if (text.from_identity == vue.to_user.from_identity) {
									vue.msglist.push(text)
									vue.setPageScrollTo()
								}

							} else if (text.xx_type == 'other') {
								if (text.from_identity == vue.to_user.from_identity) {
									vue.msglist.push(text)
									vue.setPageScrollTo()
									vue.claerydxx(text)
									if (vue.xxitem.inquiry_type == 4) {
										vue.getLists2()
									}
									vue.$refs.chatlists.getList()
								} else {
									await vue.$refs.chatlists.getList()
									await vue.$openws.getover('inquiry', '')
									await vue.$refs.headered.getis_noread()
								}
							}
							for (const v of vue.msglist) {
								if (v && v.send_context && v.send_context[0] == "{") {
									let d
									try {
										d = JSON.parse(v.send_context)
										v.type = d.type
										v.info = d
									} catch (error) {

									}
								}
							}
						};
						// 接诊提醒
						vue.$openws.ws.inquiryRemind = function (text, type) {
							vue.$notify.info({
								title: '新咨询订单',
								message: text.data,
								position: 'bottom-right',
							});
						};
					},
					send(d, count = 0) {
						if (!vue.value.text && !d) return
						// _('发送消息')
						var params = {
							// text: vue.value.text,
							// type: "text",
							// from_id: vue.usered.id,
							// from_avatar: vue.usered.avatar,
							// from_nickname: vue.usered.nickname,
							// from_user_type: vue.user_type,
							// to_user_type: vue.to_user.show_user_type,
							// to_id: vue.to_user.show_user_id,
							// to_avatar: vue.to_user.show_avatar,
							// to_nickname: vue.to_user.show_nickname,
							// time: "",

							show_avatar: vue.xxitem.my_avatar,
							show_nickname: vue.xxitem.my_name,
							fictitious_user_id: vue.xxitem.is_fictitious_user == 1 ?
								vue
								.xxitem.my_id : 0,

							to_nickname: vue.xxitem.show_name,
							inquiry_id: vue.to_user.id,
							from_id: vue.usered.id,
							to_id: vue.xxitem.patient_id,
							send_context: d ? d : vue.value.text,
							msg_type: 'text',
							zs_count: count

						}
						if (vue.$openws.ws.getState() != 1) {
							let load = vue.$message({
								message: ' 连接异常断开，正在进行重连，请稍后',
								iconClass: 'el-icon-loading',
								duration: 0
							});
							if (vue.$openws.ws && vue.$openws.ws.getState()) {
								vue.$openws.ws.close()
								setTimeout(() => {
									vue.$openws.openws()
								}, 500)

							} else {
								setTimeout(() => {
									vue.$openws.openws()
								}, 500)
							}
							setTimeout(() => {
								if (vue.$openws.ws.getState() == 1) {
									load.close()
									vue.$message.success('连接成功')
								} else {

								}
								vue.on.connect(1)
							}, 2000)
							return
						}
						let token = sessionStorage.getItem('token')

						vue.$openws.ws.send('index/server/sendInquiryMsg', vue.to_user.patient_id, params,
							`manager_${token}`, JSON.parse(
								sessionStorage.getItem('doc_data')))
						vue.value.text = '';
						vue.$refs.chatlists.getList()
					}
				}
			}
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			})
		},
		created() {
			var vue = this;
			vue.on.connect();
			vue.getsongcount()

		},
		watch: {
			'opws.is_state'(nval, oval) {
				console.log(new Date(+new Date() + 8 * 3600 * 1000).toJSON().substr(0, 19).replace("T", " ") + '---新状态:',
					nval);
				if (nval == 1) {
					this.on.connect()
				}
			}
		},
		mounted() {
			var vue = this;
			vue.bus.$on('selectRightMenu', data => {
				this.top_tabId = data
			})
		},
		destroyed() {
			this.to_user.from_identity = '0'
			this.$openws.connect()
		},
		methods: {
			//滚动到顶部
			scrollHandler() {
				this.page++
				this.getjlxx()
			},
			listen(e) {
				if (e.keyCode == 13) {
					e.preventDefault()
					return false
				}
			},
			async getallxx() {
				var start
				if (this.xxitem.reception_time) {
					start = new Date(this.xxitem.reception_time.replace(/-/g, '/')).getTime();
				}
				if (!start) {
					this.vshow = false
					return
				}
				if (this.xxitem.inquiry_type != 4) {
					var now = new Date().getTime()

					if (Number(now) - Number(start) > Number(24 * 3600 * 1000)) {
						this.vshow = false
						clearInterval(this.timer); // 清除定时器
						this.timer = null;
						clearInterval(this.djs)
						this.djs = null
						// this.getsx()
					} else {
						this.vshow = true
						this.djs = setInterval(() => {
							var now2 = new Date().getTime()
							let mss = Number(24 * 3600 * 1000) - (Number(now2) - Number(start))
							var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
							var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
							this.sytime = hours + '时' + minutes + '分'
							if (this.sytime == '0时0分') {
								clearInterval(this.djs)
								this.djs = null
								this.vshow = false
							}
						}, 1000)
					}
				} else {
					if ((this.mr_count + this.xxitem.reply_count - this.xxitem.count) <= 0) {
						this.vshow = false
						this.zx_S_count = (this.mr_count + this.xxitem.reply_count)
					}
				}
			},
			//点击左边数据
			async setDataId(data) {
				clearInterval(this.djs)
				this.djs = null
				this.to_user = data
				await this.getLists()
				this.msglist = []
				this.isScroll = true
				this.getjlxx(1)

				await this.$openws.getover('inquiry', 'clear')
				await this.$refs.headered.getis_noread()
				if (this.top_tabId == 0) {
					this.$nextTick(() => {
						this.$refs.userDetail.getList()
					})
				} else if (this.top_tabId == 1) {
					this.$nextTick(() => {
						this.$refs.tranorder.getList()
					})
				} else if (this.top_tabId == 2) {
					this.$nextTick(() => {
						this.$refs.headered.selectTab({
							key: 1,
							title: '交易订单',
						})
					})

				}

			},
			async getLists() {
				if (!this.to_user.id) {
					return false
				}
				axios.post('/admin/pc/DoctorInquiry/read', {
					id: this.to_user.id,
					user: JSON.parse(sessionStorage.getItem('doc_data'))
				}, {
					token: true
				}).then(async res => {
					this.xxitem = res.data.data
					if (this.xxitem.inquiry_type == 4) {
						this.input_tip = '用户剩余' + (this.mr_count + this.xxitem.reply_count -
								this
								.xxitem
								.count) +
							'次沟通次数'
					} else {
						this.input_tip = ''
					}
					if (this.to_user.no_read > 0) {
						await this.claerydxx({
							msg_id: this.xxitem.end_up_msg_id,
							from_id: this.xxitem.patient_id,
							to_id: this.xxitem.doc_id,
						})
					}
					await this.$refs.chatlists.getList()
					await this.getallxx()

				}).catch((error) => {
					console.log(error);
				})
			},
			getLists2(t = 1) {
				if (!this.to_user.id) {
					return false
				}
				axios.post('/admin/pc/DoctorInquiry/read', {
					id: this.to_user.id,
					user: JSON.parse(sessionStorage.getItem('doc_data'))
				}, {
					token: true
				}).then(async res => {
					let xxitem = res.data.data
					if (t == 2) {
						this.xxitem = res.data.data
					}
					let count = (this.mr_count + xxitem.reply_count - xxitem.count)
					this.input_tip = '用户剩余' + count + '次沟通次数'
					if (count == 0) {
						this.vshow = false
						// this.zx_S_count = (this.mr_count + xxitem.reply_count)
						// if (this.users.customer_type == 1) {
						// 	this.$http.bdwc({
						// 		id: id
						// 	}).then((res) => {})
						// }
					}
				}).catch((error) => {
					console.log(error);
				})
			},
			getsongcount() {
				axios.post('/admin/pc/DoctorInquiry/get_reply_config', {}, {
					token: true
				}).then(res => {
					this.zx_count = res.data.data.count
					this.zx_timer = res.data.data.time
					this.mr_count = res.data.data.default_count

				}).catch((error) => {
					console.log(error);
				})
			},
			songcount() {
				this.$confirm(`此操作将赠送报到用户${this.zx_count}次沟通机会,${this.zx_timer}内有效, 是否继续?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					axios.post('/admin/pc/DoctorInquiry/set_reply_config', {
						id: this.xxitem.id,
					}, {
						token: true
					}).then(res => {
						if (res.data.code == 200) {
							this.$message({
								type: 'success',
								message: '赠送成功!'
							});
							let s = `已赠送您${this.zx_count}次沟通次数(${this.zx_timer}天内有效)`
							this.on.send(s, this.zx_count)
							this.getLists2(2)
						} else {
							this.$message.error(res.data.msg)
						}
					}).catch((error) => {
						console.log(error);
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取'
					});
				});
			},
			// 聊天记录
			getjlxx(t) {
				let vue = this
				axios.post('/admin/pc/DoctorInquiryLogs/index', {
					page: this.page,
					page_count: 10,
					user_id: vue.user_id,
					from_id: this.to_user.show_user_id,
					from_user_type: vue.to_user.show_user_type,

					inquiry_id: vue.to_user.id,
					// author: this.users.id,

					user: JSON.parse(sessionStorage.getItem('doc_data'))
					// to_user_type: vue.user_type,
				}, {
					token: true
				}).then(res => {

					var lists = res.data.data.list
					if (lists) {
						this.msglist = [...lists, ...this.msglist];
					}
					for (const v of this.msglist) {
						if (v && v.send_context && v.send_context[0] == "{") {
							let d
							try {
								d = JSON.parse(v.send_context)
								v.type = d.type
								v.info = d
							} catch (error) {

							}
						}
					}

					if (t == 1) {
						vue.setPageScrollTo()
					}
				})
			},
			// 清除已读消息
			async claerydxx(data) {
				let vue = this
				let params = {
					msg_id: data.msg_id,
					from_id: data.from_id,
					to_id: data.to_id,
					inquiry_id: vue.to_user.id
				}

				vue.$openws.ws.send('index/server/inquiryMsgReceipt', params)
			},
			// 设置页面滚动位置
			setPageScrollTo() {
				this.$nextTick(() => {
					this.scrollTop = document.querySelector("#chat_scroll").offsetHeight
					setTimeout(res => {
						if (this.scrollTop != this.$refs.scrollBox.offsetHeight) {
							this.scrollTop = document.querySelector("#chat_scroll").offsetHeight
						}
					}, 300)
				})
			},
			handleSuccess(file) {
				let vue = this
				if (file.code == '200') {
					var params = {
						// text: file.data.url,
						// type: "image",
						// from_id: vue.usered.id,
						// from_avatar: vue.usered.avatar,
						// from_nickname: vue.usered.nickname,
						// from_user_type: vue.user_type,
						// to_user_type: vue.to_user.show_user_type,
						// to_id: vue.to_user.show_user_id,
						// to_avatar: vue.to_user.show_avatar,
						// to_nickname: vue.to_user.show_nickname,
						// time: "",
						// media_id: file.data.media_id,

						show_avatar: vue.xxitem.my_avatar,
						show_nickname: vue.xxitem.my_name,
						fictitious_user_id: vue.xxitem.is_fictitious_user == 1 ?
							vue
							.xxitem.my_id : 0,

						to_nickname: vue.xxitem.show_name,
						inquiry_id: vue.to_user.id,
						from_id: vue.usered.id,
						to_id: vue.xxitem.patient_id,
						send_context: file.data.url,
						msg_type: 'image',
						zs_count: 0
					}
					let token = sessionStorage.getItem('token')
					vue.$openws.ws.send('index/server/sendInquiryMsg', vue.to_user.patient_id, params, `manager_${token}`,
						JSON.parse(
							sessionStorage.getItem('doc_data')))
				}

			},
			selectorder(item) {
				this.to_order = item
				this.$nextTick(() => {
					this.$refs.orderDetail.getList()
				})
			},
			dk() {
				this.$openws.ws.close()
				this.$message('已断开')
			},

		}
	}
</script>


<style lang="scss" scoped>
	.main {
		margin: -1rem -20px -60px -20px;
		height: calc(100% + 25px);

		.bls {
			height: 100%;
			display: flex;

			.bl1 {
				width: 200px;

				.lis {
					.ite {
						&.on {
							color: red;
						}
					}
				}
			}

			.bl2 {
				flex: 1;
				width: 0;
				border-left: 1px solid #ccc;
				border-right: 1px solid #ccc;
				display: flex;
				flex-flow: column;

				.msgs {
					flex: 1;
					height: 0;
				}

				.bd {
					.conn {
						display: flex;

						.in {
							flex: 1;
						}
					}
				}
			}

			.bl3 {
				width: 200px;
			}
		}
	}

	.content-wrapper {
		display: flex;
		flex-direction: column;
		width: 1200px;
		height: 808px;
		// margin: 0 auto;
		background: #fff;
	}

	.chat-content {
		width: 600px;
		height: 100%;
		border-right: 1px solid #ECECEC;

		.chat-body {
			height: 530px;

			.chat-item {
				padding-bottom: 24px;

				.time {
					text-align: center;
					color: #999999;
					font-size: 14px;
					margin: 18px 0;
				}

				.flex-box {
					display: flex;

					.mag_r {
						display: flex;
						flex-direction: column;
						align-items: flex-start;
					}

					.msg_in_b {
						display: flex;
						align-items: flex-start;
					}
				}

				.r_msg_b {
					.mag_r {
						display: flex;
						flex-direction: column;
						align-items: flex-end;
					}

					.msg_in_b {
						display: flex;
						// align-items: flex-end;
						flex-direction: row-reverse;

					}
				}

				.rgs {
					flex-direction: row-reverse;
				}

				.avatar {
					width: 40px;
					height: 40px;
					// margin-right: 16px;

					img {
						display: block;
						width: 100%;
						height: 100%;
						border-radius: 50%;
					}
				}



				.mc {
					color: #b2b2b2;
					font-size: 13px;
				}


				.msg-wrapper {
					max-width: 320px;
					background: #f8f8f8;
					border-radius: 5px;
					color: #000000;
					font-size: 14px;
					overflow: hidden;
					padding: 5px;

					.txt-wrapper {
						word-break: break-all;
					}

					.pad16 {
						padding: 9px;
					}

					.img-wraper img {
						max-width: 100%;
						height: auto;
						display: block;
					}


				}

				.wd {
					// background-color: #f8f8f8;
					color: #999;
					font-size: 12px;
					padding: 0 5px;
				}

				.yd {
					// background-color: #f8f8f8;
					color: #89C659;
					font-size: 12px;
					padding: 0 5px;

				}

				.content_b {
					word-break: break-all;
				}

				.sharewz_b {

					.wz_img {
						margin-right: 5px;

						/deep/ div {
							display: block;
						}
					}

					.wz_info {
						flex: 1;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;

						.wztit {
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							font-size: 16px;
						}

						.wzcons {
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
							overflow: hidden;
							white-space: normal;
							font-size: 14px;
							color: #5f5f5f;
						}
					}
				}

				.wz_b {
					.s_cover {
						width: 100%;
						padding-top: 100%;
						background-size: cover !important;
						background-repeat: no-repeat !important;
						background-position: center !important;
						border-radius: 5px;
					}

					.s_price {
						color: red;
						font-size: 12px;
						padding: 3px 0;

						.s_p_in {
							font-size: 14px;
						}
					}

					.s_tit {
						font-size: 14px;

					}

					.s_con {
						color: #999;
						font-size: 12px;
					}
				}
			}
		}
	}

	.right_b {
		flex: 1;
		overflow: auto;
	}

	.chat-textarea {
		height: 214px;
		border-top: 1px solid #ECECEC;

		.chat-btn-wrapper {
			position: relative;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 15px 0;
		}

		.left-wrapper {
			display: flex;
			align-items: flex-start;

			.icon-item {
				display: flex;
				align-items: center;
				margin-left: 20px;
				cursor: pointer;

				.iconfont {
					font-size: 22px;
					color: #333333;
				}
			}
		}

		.right-wrapper {
			position: relative;
			padding-right: 20px;

			.icon-item {
				display: flex;
				align-items: center;
				font-size: 15px;
				color: #333;
				cursor: pointer;

				span {
					margin-left: 10px;
				}
			}

			.transfer-box {
				z-index: 60;
				position: absolute;
				right: 1px;
				bottom: 43px;
				width: 140px;
				background: #fff;
				box-shadow: 0 4px 12px rgba(0, 0, 0, .15);
				padding: 16px;
			}

			.transfer-bg {
				z-index: 50;
				position: fixed;
				left: 0;
				top: 0;
				width: 100%;
				height: 100%;
				background: transparent;
			}
		}

		.emoji-box {
			position: absolute;
			left: 0;
			top: 0;
			transform: translateY(-100%);
			display: flex;
			flex-wrap: wrap;
			width: 60%;
			padding: 15px 9px;
			box-shadow: 0px 0px 13px 1px rgba(0, 0, 0, .1);
			background: #fff;

			.emoji-item {
				margin-right: 13px;
				margin-bottom: 8px;
				cursor: pointer;

				&:nth-child(10n) {
					margin-right: 0;
				}

			}
		}
	}

	.send-btn {
		position: absolute;
		right: 0;
		bottom: 10px;
		display: flex;
		justify-content: flex-end;
		margin-top: 10px;
		margin-right: 10px;
		width: 80px;

		.btns {
			width: 100%;
			background: #3875EA;
		}
	}

	.sy_time {
		font-size: 16px;
		color: #52ca00;
	}
</style>